import { Container, Graphics } from "pixi.js"
import { Coordinate } from "game-common/models"

/** A sharp contact flash, a low dust puff, and six little clods that fall back to the floor. */
export class ArrowGroundImpact {
    private impacts: { art: Graphics; start: number; strength: number; angle: number }[] = []

    emit(surface: Container, at: Coordinate, angle = 0, strength = 1): void {
        if (this.impacts.length >= 24) this.impacts.shift()?.art.destroy()
        const art = new Graphics()
        art.position.set(at.x, at.y)
        art.zIndex = 100 + at.y
        surface.addChild(art)
        this.impacts.push({ art, start: performance.now(), strength: Math.max(.6, Math.min(2, strength)), angle })
        this.update()
    }

    update(): void {
        const now = performance.now()
        this.impacts = this.impacts.filter(impact => {
            const { art, start, strength, angle } = impact
            if (art.destroyed) return false
            const t = Math.max(0, now - start) / 420
            if (t >= 1) { art.destroy(); return false }
            art.clear()
            const spread = 1 - Math.pow(1 - t, 3)
            // A compressed ring and dust stay on the ground; the flecks have their own short arcs.
            art.lineStyle(1, 0xd6b682, .6 * Math.pow(1 - t, 2))
            art.drawEllipse(0, 0, (2 + 10 * spread) * strength, (1 + 3 * spread) * strength)
            art.lineStyle(0)
            art.beginFill(0xb6976d, .28 * Math.pow(1 - t, 2))
            art.drawEllipse(Math.cos(angle) * 3 * spread, -2 * spread, (2 + 7 * spread) * strength, (1 + 4 * spread) * strength)
            art.endFill()
            for (let i = 0; i < 6; i++) {
                const direction = angle + i * Math.PI / 3
                const radius = (6 + i % 3 * 3) * strength * spread
                const lift = Math.sin(Math.PI * Math.min(1, t * 1.5)) * (3 + i % 2 * 3) * strength
                art.beginFill(i % 2 ? 0x806345 : 0xc5a574, Math.pow(1 - t, 1.3))
                art.drawRect(Math.cos(direction) * radius, Math.sin(direction) * radius * .35 - lift, 1.5, 1.5)
                art.endFill()
            }
            return true
        })
    }

    clear(): void {
        for (const impact of this.impacts) impact.art.destroy()
        this.impacts = []
    }
}
